"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
class RoleBillingRateCalculator {
    constructor() { }
    calculateBillingRateForRole(loadedCost, utilization, margin) {
        const numerator = new bignumber_js_1.default(1);
        const denominator = new bignumber_js_1.default(1).minus(margin);
        if (utilization.isLessThanOrEqualTo(0)) {
            throw new Error('utilization must be greater than 0');
        }
        const utilizationCostRate = loadedCost.dividedBy(utilization);
        const markup = numerator.dividedBy(denominator);
        const billingRate = utilizationCostRate.multipliedBy(markup);
        return billingRate;
    }
    calculateRevenue(billingRate, utilization, workHours) {
        return billingRate.multipliedBy(workHours.multipliedBy(utilization));
    }
    calculateGlobalMargin(totalRevenue, loadedCost, totalHours) {
        if (totalRevenue.isZero()) {
            throw new Error('Expected total revenue should be non zero');
        }
        return totalRevenue
            .minus(loadedCost.multipliedBy(totalHours))
            .dividedBy(totalRevenue);
    }
    calculateGlobalUtilization(totalLikelyHours, totalHours) {
        if (totalHours.isZero()) {
            throw new Error('Total hours should not be zero');
        }
        return totalLikelyHours.dividedBy(totalHours);
    }
    calculateMargin(roleRevenue, loadedCost, totalHours) {
        if (roleRevenue.isZero()) {
            throw new Error('Role Revenue should not be zero');
        }
        return roleRevenue
            .minus(loadedCost.multipliedBy(totalHours))
            .dividedBy(roleRevenue);
    }
    calculateMarginFromBillingRate(billingRate, utilization, loadedCost) {
        if (utilization.isZero()) {
            throw new Error('Utilization should not be zero');
        }
        if (billingRate.isZero()) {
            throw new Error('Billing rate should not be zero');
        }
        const divisor = billingRate.multipliedBy(utilization);
        return new bignumber_js_1.default(1).minus(loadedCost.dividedBy(divisor));
    }
    calculateGlobalBillingRate(revenue, utilization, workHours) {
        if (utilization.isZero()) {
            throw new Error('Utilization should not be zero');
        }
        if (workHours.isZero()) {
            throw new Error('Total hours should not be zero');
        }
        return revenue.dividedBy(workHours.multipliedBy(utilization));
    }
    calculateProfit(revenue, totalCostRate, totalHours) {
        return revenue.minus(totalCostRate.times(totalHours));
    }
    /**
     * @param loadedCost
     * @param margin
     * @param billingRate
     *
     * Formula to calculate :- utilization = (loadedCost * (1 / (1 - margin))) / billingRate
     */
    calculateUtilizationFromBillingRate(loadedCost, margin, billingRate) {
        if (billingRate.isZero()) {
            throw new Error('Billing rate should not be zero');
        }
        const numerator = new bignumber_js_1.default(1);
        const denominator = new bignumber_js_1.default(1).minus(margin);
        const markup = numerator.dividedBy(denominator);
        return loadedCost.times(markup).dividedBy(billingRate);
    }
}
RoleBillingRateCalculator.DEFAULT_MARGIN = new bignumber_js_1.default(0.35);
RoleBillingRateCalculator.DEFAULT_UTILIZATION = new bignumber_js_1.default(0.8);
exports.default = RoleBillingRateCalculator;
//# sourceMappingURL=RoleBillingRateCalculator.js.map